import { createFileRoute, useParams } from "@tanstack/react-router";

import { FillScreen, VStack } from "@/components/Layout";

import AccessibleProductsCard from "./-component/AccessibleProductsCard";
import BasicCard from "./-component/BasicCard";
import HeaderDetailProductPermission from "./-component/HeaderDetailProductPermission";
import RoleUsingCard from "./-component/RoleUsingCard";
import useGetProductPermissionDetail from "./-query/useGetProductPermissionDetail";

export const Route = createFileRoute(
  "/_staff/settings/permission-and-roles/_detail/product-permissions/$id/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: productLevelAccessPermissionId } = useParams({
    from: "/_staff/settings/permission-and-roles/_detail/product-permissions/$id/",
  });

  const { data, isPending } = useGetProductPermissionDetail({
    productLevelAccessPermissionId,
  });

  return (
    <VStack>
      <HeaderDetailProductPermission data={data} />

      <FillScreen className="flex flex-col gap-7 p-10">
        <BasicCard data={data} />
        <AccessibleProductsCard data={data} isPending={isPending} />
        <RoleUsingCard data={data} isPending={isPending} />
      </FillScreen>
    </VStack>
  );
}
